<template>
  <div class="question-container" :class="[displayMode, { 'is-nested': isNested }]">
    <div class="question-title-container">
      <!-- <el-tag v-show="isRequired" class="title-tag" color="#F56C6C">{{ $t(`${i18nPrefix}.label.required`) }}</el-tag>
      <el-tag class="title-tag" :color="QUESTION_TYPE_COLOR[type]" :style="{ borderColor: QUESTION_TYPE_COLOR[type] }">{{ $t(`${i18nPrefix}.questionType.${type}`) }}</el-tag> -->
      <template v-if="isTreePresentation">
        <span v-if="!isNested" class="question-title question-number">{{ $t(`${i18nPrefix}.label.questionnaireQuestion`) }} {{ questionNumber }}<span v-if="isRequired" class="required-mark" aria-hidden="true">*</span>: </span>
        <span class="question-title-group">
          <a v-if="type === QUESTION_TYPE.POLICY" class="question-title link" target="_blank" :href="policyLink" v-html="title"></a>
          <span v-else class="question-title" v-html="title"></span>
          <span v-if="isNested && isRequired" class="required-mark" aria-hidden="true">*</span>
        </span>
      </template>
      <template v-else>
        <span v-show="!isHrSurvey" class="question-title">{{ $t(`${i18nPrefix}.label.question`) }}</span>
        <a v-if="type === QUESTION_TYPE.POLICY" class="question-title link" target="_blank" :href="policyLink" v-html="title"></a>
        <span v-else class="question-title" v-html="title"></span>
      </template>
      <template v-if="isRequired && !isTreePresentation">
        <span class="required-mark" aria-hidden="true">*</span>
        <span class="required-description">{{ $t(`${i18nPrefix}.label.required`) }}</span>
      </template>
      <span v-else-if="isRequired" class="required-description">{{ $t(`${i18nPrefix}.label.required`) }}</span>
    </div>
    <div v-show="errorMessage" class="error-message">{{ errorMessage }}</div>
    <div class="question-answer-wrapper">
      <template v-if="type === QUESTION_TYPE.SELECT">
        <el-select filterable clearable v-model="answerValue" class="question-answer">
          <el-option v-for="(option, index) in optionList" :key="index" :value="option.value" :label="option.label"></el-option>
        </el-select>
        <slot name="answer-child"></slot>
      </template>
      <template v-else-if="type === QUESTION_TYPE.MULTIPLE">
        <el-select filterable multiple clearable v-model="answerValue" class="question-answer">
          <el-option v-for="(option, index) in optionList" :key="index" :value="option.value" :label="option.label"></el-option>
        </el-select>
        <slot name="answer-child"></slot>
      </template>
      <el-radio-group v-else-if="type === QUESTION_TYPE.RADIO" v-model="answerValue" class="question-answer">
        <template v-if="isTreePresentation">
          <div v-for="(option, index) in optionList" class="question-option-block" :key="index">
            <el-radio class="question-option" :label="option.value">{{ option.label }}</el-radio>
            <slot name="option-child" :option="option"></slot>
          </div>
        </template>
        <el-radio v-else v-for="(option, index) in optionList" class="question-option" :key="index" :label="option.value">{{ option.label }}</el-radio>
      </el-radio-group>
      <el-checkbox-group v-else-if="type === QUESTION_TYPE.CHECKBOX" v-model="answerValue" class="question-answer">
        <template v-if="isTreePresentation">
          <div v-for="(option, index) in optionList" class="question-option-block" :key="index">
            <el-checkbox class="question-option" :label="option.value">{{ option.label }}</el-checkbox>
            <slot name="option-child" :option="option"></slot>
          </div>
        </template>
        <el-checkbox v-else v-for="(option, index) in optionList" class="question-option" :key="index" :label="option.value">{{ option.label }}</el-checkbox>
      </el-checkbox-group>
      <el-date-picker v-else-if="type === QUESTION_TYPE.DATE" v-model="answerValue" class="question-answer" type="date"></el-date-picker>
      <el-checkbox v-else-if="type === QUESTION_TYPE.POLICY" v-model="answerValue" class="question-answer">{{ $t(`${i18nPrefix}.label.agree`) }}</el-checkbox>
      <el-input v-else-if="type === QUESTION_TYPE.TEXTAREA" v-model="answerValue" class="question-answer" type="textarea" :autosize="this.autosize || { minRows: 4 }"></el-input>
      <div v-else-if="[QUESTION_TYPE.ATTACHMENT, QUESTION_TYPE.VIDEO].includes(type)" class="question-answer file-uploader">
        <input v-show="false" ref="fileInput" type="file" :accept="uploadFileAcceptType" @change="handleFileChange"/>
        <div class="file-status">
          <i class="status-icon" :class="fileStatusIconClass"></i>
          <span class="status">{{ fileStatusLabel }}</span>
        </div>
        <el-button class="upload-btn" :disabled="isUploading" @click="handleUploadBtnClick">{{ $t(`${i18nPrefix}.btn.upload.${hasUploaded ? 'selectAnotherFile' : 'selectFile'}`) }}</el-button>
        <div class="upload-tip">
          <div v-for="(item, index) in uploaderTipList" class="tip-message" :key="index">{{ item }}</div>
        </div>
        <div v-if="uploaderNeedFileDescription" class="file-description">
          <el-input v-model="fileDescription" :placeholder="$t(`${i18nPrefix}.placeholder.uploadFileDescription`)"></el-input>
        </div>
      </div>
      <el-input v-else v-model="answerValue" class="question-answer"></el-input>
    </div>
  </div>
</template>

<script>

export const QUESTION_TYPE = {
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  SELECT: 'SELECT',
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
  DATE: 'DATE',
  VIDEO: 'VIDEO',
  ATTACHMENT: 'ATTACHMENT',
  POLICY: 'POLICY',
  MULTIPLE: 'MULTIPLE'
}

const QUESTION_TYPE_COLOR = {
  [QUESTION_TYPE.TEXT]: '#67C23A',
  [QUESTION_TYPE.TEXTAREA]: '#67C23A',
  [QUESTION_TYPE.SELECT]: '#E6A23C',
  [QUESTION_TYPE.RADIO]: '#E6A23C',
  [QUESTION_TYPE.CHECKBOX]: '#E6A23C',
  [QUESTION_TYPE.DATE]: '#909399',
  [QUESTION_TYPE.VIDEO]: '#409EFF',
  [QUESTION_TYPE.ATTACHMENT]: '#409EFF',
  [QUESTION_TYPE.POLICY]: '#409EFF'
}

export default {
  model: {
    prop: 'answer',
    event: 'change'
  },
  props: {
    isRequired: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    type: {
      type: String,
      required: true
    },
    surveyType: {
      type: String,
      default: 'standard'
    },
    answer: {
      default: null
    },
    optionList: {
      type: Array,
      default: null
    },
    uploaderTipList: {
      type: Array,
      default: null
    },
    uploaderFileSize: {
      type: Number,
      default: null
    },
    uploaderFileTypeList: {
      type: Array,
      default: null
    },
    uploaderNeedFileDescription: {
      type: Boolean,
      default: false
    },
    uploaderFileDescription: {
      type: String,
      default: null
    },
    policyLink: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    autosize: {
      type: Object,
      default: null
    },
    displayMode: {
      type: String,
      default: ''
    },
    questionNumber: {
      type: Number,
      default: null
    },
    isNested: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      QUESTION_TYPE,
      QUESTION_TYPE_COLOR,
      i18nPrefix: 'admin.application.candidate',
      isUploading: false
    }
  },
  computed: {
    isTreePresentation () {
      return ['candidate-answer', 'hr-sidebar'].includes(this.displayMode)
    },
    fileStatusLabel () {
      let i18nKey = null
      if (this.isUploading) {
        i18nKey = 'uploading'
      } else if (this.hasUploaded) {
        i18nKey = 'uploaded'
      } else {
        i18nKey = 'empty'
      }
      return this.$t(`${this.i18nPrefix}.fileUpload.${i18nKey}`)
    },
    fileStatusIconClass () {
      let className = null
      if (this.isUploading) {
        className = 'el-icon-loading uploading'
      } else if (this.hasUploaded) {
        className = 'el-icon-circle-check uploaded'
      } else {
        className = 'el-icon-warning-outline empty'
      }
      return className
    },
    hasUploaded () {
      return !this.isUploading && this.answerValue
    },
    uploadFileAcceptType () {
      if (this.uploaderFileTypeList) {
        return this.uploaderFileTypeList.join(',')
      }
      return null
    },
    answerValue: {
      get () {
        return this.answer
      },
      set (val) {
        this.$emit('change', val)
      }
    },
    fileDescription: {
      get () {
        return this.uploaderFileDescription
      },
      set (val) {
        this.$emit('update:uploaderFileDescription', val)
      }
    },
    isHrSurvey () {
      if (this.surveyType === 'hr') {
        return true
      }
      return false
    }
  },
  created () {

  },
  methods: {
    handleUploadBtnClick () {
      this.$refs.fileInput.click()
    },
    handleFileChange () {
      const fileInput = this.$refs.fileInput
      const selectedFile = fileInput.files[0]
      if (!selectedFile) {
        return
      }
      this.isUploading = true
      this.$emit('file-upload', selectedFile, this.handleFileUploaded)
    },
    handleFileUploaded () {
      this.isUploading = false
      this.$refs.fileInput.value = null
    }
  }
}
</script>

<style lang="scss" scoped>
.question-container {
  margin-bottom: 25px;

  .question-title-container {
    .required-mark {
      margin-left: 4px;
      color: #F56C6C;
    }

    .required-description {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    .title-tag {
      height: initial;
      margin-right: 5px;
      padding: 2px 8px;
      border-radius: 6px;
      border-width: 0;
      line-height: initial;
      color: #ffffff;
      vertical-align: middle;
    }

    .question-title {
      height: 32px;
      line-height: 32px;
      font-size: 18px;
      vertical-align: middle;
      white-space: break-spaces;
      word-break: break-word;
    }
  }

  .error-message {
    color: #F56C6C;
    font-size: 14px;
  }

  .question-answer-wrapper {
    margin-top: 5px;

    .question-answer {
      width: 100%;

      .question-option {
        display: inline-block;
        width: 100%;
        margin-right: 0;

        + .question-option {
          margin-top: 10px;
        }
      }

      &.file-uploader {
        .file-status {
          .status-icon {
            position: relative;
            top: 2px;
            font-size: 18px;

            &.empty {
              color: #E6A23C;
            }

            &.uploaded {
              color: #67C23A;
            }
          }

          .status {
            margin-left: 5px;
            font-size: 14px;
          }
        }

        .upload-btn {
          margin-top: 10px;
          padding: 10px 15px;
          border: 0;
          background-color: #409EFF;
          color: #ffffff;
        }

        .upload-tip {
          margin-top: 5px;
          font-size: 12px;
        }

        .file-description {
          margin-top: 10px;
        }
      }
    }

    ::v-deep {
      .el-select {
        width: 100%;

        .el-input {
          .el-input__icon {
            line-height: inherit;
          }

          &.is-focus {
            .el-input__inner {
              border-color: #409EFF;
            }
          }
        }

        .el-select__input {
          margin-left: 5px;
        }
      }

      .el-input {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
          padding: 0 5px;
          border-radius: 0;
          color: #232323;

          &:focus {
            border-color: #b2b2b2;
          }

          &:hover {
            border-color: #C0C4CC;
          }
        }

        &.el-input--prefix {
          .el-input__inner {
            padding-left: 30px;
          }

          .el-input__prefix {
            .el-input__icon {
              line-height: inherit;
            }
          }
        }

        &.el-input--suffix {
          .el-input__suffix {
            .el-input__icon {
              line-height: inherit;
            }
          }
        }

        &.password-input {
          .el-input__inner {
            padding-right: 50px;
          }

          .el-input__suffix {
            right: 20px;
          }
        }

        &.is-disabled  {
          .el-input__inner {
            background-color: #F5F7FA;
            border-color: #E4E7ED;
            color: #C0C4CC;
            cursor: not-allowed;
          }
        }
      }

      .el-textarea {
        .el-textarea__inner {
          padding: 5px 10px;
          border-radius: 0;
        }
      }

      .el-date-editor {
        width: 100%;

        .el-input__icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

.question-container.candidate-answer {
  margin-bottom: 10px;
  color: #333;

  .question-title-container {
    font-size: 0;

    .question-title {
      height: auto;
      color: #333;
      font-size: 18px;
      font-weight: 500;
      line-height: 32px;
    }

    .question-number {
      line-height: 32px;
    }

    .required-mark {
      display: inline-block;
      margin-left: 0;
      font-size: 18px;
      line-height: 1;
      vertical-align: middle;
      transform: translateY(1px);
    }
  }

  &.is-nested .question-title-container .question-title {
    line-height: normal;
  }

  .error-message {
    font-size: 12px;
  }

  .question-answer-wrapper {
    margin-top: 5px;

    .question-option-block + .question-option-block {
      margin-top: 10px;
    }

    ::v-deep {
      .el-radio,
      .el-checkbox {
        display: flex;
        min-height: 16px;
        margin-right: 0;

        .el-radio__inner,
        .el-checkbox__inner {
          width: 14px;
          height: 14px;
        }

        .el-radio__label,
        .el-checkbox__label {
          padding-left: 10px;
          color: #606266;
          font-weight: 400;
          line-height: 16px;
          white-space: normal;
        }
      }

      .el-textarea .el-textarea__inner {
        padding: 8px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        color: #606266;
        font-size: 14px;
        line-height: 14px;
      }
    }
  }

  &.is-nested > .question-answer-wrapper {
    margin-top: 10px;
  }
}

.question-container.hr-sidebar {
  margin-bottom: 0;
  color: #606266;

  .question-title-container {
    font-size: 0;

    .question-title {
      height: auto;
      color: #606266;
      font-size: 14px;
      font-weight: 400;
      line-height: normal;
    }

    .required-mark {
      display: inline-block;
      margin-left: 0;
      font-size: 14px;
      line-height: 1;
      vertical-align: middle;
      transform: translateY(1px);
    }
  }

  &.is-nested .question-title-container .question-title {
    color: #676767;
  }

  .question-answer-wrapper {
    margin-top: 8px;

    .question-option-block + .question-option-block {
      margin-top: 8px;
    }

    ::v-deep {
      .el-radio,
      .el-checkbox {
        display: flex;
        min-height: 14px;
        margin-right: 0;

        .el-radio__inner,
        .el-checkbox__inner {
          width: 14px;
          height: 14px;
        }

        .el-radio__label,
        .el-checkbox__label {
          padding-left: 8px;
          color: #606266;
          font-size: 14px;
          font-weight: 400;
          line-height: 16px;
          white-space: normal;
        }
      }

      .el-textarea .el-textarea__inner {
        padding: 8px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        color: #606266;
        font-size: 14px;
        line-height: 14px;
      }
    }
  }

  &:not(.is-nested) > .question-answer-wrapper {
    margin-top: 10px;
  }
}

.question-container.question-container.candidate-answer,
.question-container.question-container.hr-sidebar {
  .question-title-container {
    display: flex;
    align-items: flex-start;
    width: 100%;
    min-width: 0;

    .question-title-group {
      flex: 1 1 auto;
      min-width: 0;
      max-width: 100%;
      white-space: normal;
      overflow-wrap: anywhere;

      .question-title {
        white-space: inherit;
      }
      .required-mark {
        transform: translateY(4px);
      }
    }

    .question-number,
    .required-mark {
      flex: 0 0 auto;
    }
  }
}

.question-container.question-container.hr-sidebar {
  .question-title-container {
    display: block;

    .question-title-group {
      display: inline;
    }
  }
}
</style>
